module.exports = __webpack_public_path__ + "img/hero.9b1b3253.jpg";